export default "__VITE_ASSET__B8sumC1V__ 100w";